/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

const PUBLISHER_MEDIA_CATEGORIES = (t: Function) => [
  {
    label: t("mediaLibrary.image"),
    value: "media-library",
    category: "PUBLISHER_MEDIA_CATEGORIES"
  }
];

const EXTERNAL_MEDIA_PROVIDERS = (t: Function) => [
  {
    label: t("mediaLibrary.getty"),
    value: "getty",
    category: "EXTERNAL_MEDIA_PROVIDERS"
  }
];

export { PUBLISHER_MEDIA_CATEGORIES, EXTERNAL_MEDIA_PROVIDERS };
